import AnalyticsDashboardApp from './AnalyticsDashboardApp';
import {authRoles} from "../../../store/actionreducers/auth/auth";

export const AnalyticsDashboardAppConfig = {
    auth: authRoles.cc, //  ['cc']
    routes  : [
        {
            path     : '/apps/dashboards/analytics',
            component: AnalyticsDashboardApp,
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/analytics/AnalyticsDashboardAppConfig.js